export const OCCUPATIONAL_THERAPIST_LISTING_COLOUMS = [
    'Client Name',
    'Note Type',
    'Note Date',
    'Created At'
]
export const OCCUPATIONAL_THERAPIST_SORTING_DATA = {
    'Client Name': 'clientName',
    'Note Type': 'noteType',
    'Note Date': 'date',
    'Created At': 'createdAt'
}   
export const OCCUPATIONAL_THERAPIST_DATA_MAPPING = {
    'Client Name': 'clientName',
    'Note Type': 'noteType',
    'Note Date': 'date',
    'Created At': 'createdAt'
}

export const OCCUPATIONAL_THERAPIST_NOTE_ENTRY_LISTING_COLOUMS = [
    'Client Name',
    'Note Type',
    'Start Date',
    'End Date',
    'Created At'
]
export const OCCUPATIONAL_THERAPIST_NOTE_ENTRY_SORTING_DATA = {
    'Client Name': 'clientName',
    'Note Type': 'noteType',
    'Start Date': 'startDate',
    'End Date': 'endDate',
    'Created At': 'createdAt'
}   
export const OCCUPATIONAL_THERAPIST_NOTE_ENTRY_DATA_MAPPING = {
    'Client Name': 'clientName',
    'Note Type': 'noteType',
    'Start Date': 'startDate',
    'End Date': 'endDate',
    'Created At': 'createdAt'
}

